import { FC } from "react";
import { CodeStaticListItemProps } from "../types";

const CodeStaticListItem : FC<CodeStaticListItemProps> = (props) => {
    return <>{props.children}</>;
};

export default CodeStaticListItem;